// DownloadSection.jsx:
import React from 'react';
// eslint-disable-next-line
import ReactPixel from 'react-facebook-pixel';
import { useTranslation } from 'react-i18next'; // Import translation hook
import { FaBuilding, FaFileContract, FaPhone } from 'react-icons/fa'; // Import icons
import { useNavigate } from 'react-router-dom'; // Import React Router for navigation
import appleDownload from '../assets/download-apple.png';
import googleDownload from '../assets/download-google.png';
import './DownloadSection.css';

// Function to handle download button click and trigger Facebook Pixel event
function handleDownloadClick(store) {
    ReactPixel.track('Lead', { platform: store }); // Track "Lead" event with platform info
}

function DownloadSection() {
    const { t } = useTranslation(); // Translation hook
    const navigate = useNavigate(); // React Router navigation

    return (
        <section className="download-section">
            <div className="download-container">
                <h2>{t("download.title")}</h2>
                <p>{t("download.subtitle")}</p>

                <div className="store-buttons">
                    <a
                        href="https://apps.apple.com/gb/app/ever/id6737575221"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleDownloadClick('App Store')}
                    >
                        <img src={appleDownload} alt={t("download.apple_alt")} />
                    </a>

                    <a
                        href="https://play.google.com/store/apps/details?id=ken.expo.eapp"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleDownloadClick('Google Play')}
                    >
                        <img src={googleDownload} alt={t("download.google_alt")} />
                    </a>
                </div>

                {/* Footer Section */}
                <div className="footer-section">
                    {/* Left - Building Icon + Address */}
                    <div className="footer-left">
                        <FaBuilding className="footer-icon" />
                        <p>Canada Water, London, UK</p>
                    </div>

                    {/* Center - Mobile Number */}
                    <div className="footer-center">
                        <FaPhone className="footer-icon" />
                        <p>+44 7872 635 307</p>
                    </div>

                    {/* Right - Terms & Privacy Policy */}
                    <div className="footer-right">
                        <FaFileContract className="footer-icon" />
                        <button
                            className="terms-button"
                            onClick={() => navigate('/Terms-Privacy')}
                        >
                            {t("terms&privacy")}
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DownloadSection;
